@use "~theme/breakpoints";
@use "~theme/typography";

.numberSelectionCard {
  margin: 18px var(--card-gutter-width);
}

.cardContents {
  padding: 28px 24px 32px;

  @include breakpoints.desktop {
    padding-left: 32px;
    padding-right: 32px;

    width: 668px;
  }
}

.headline {
  @include typography.heading3;

  margin: 0 0 8px;
}

.subhead {
  @include typography.caption;

  color: var(--black-at-75);

  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content 1fr;
  align-items: start;
  gap: 6px;

  margin-bottom: 28px;

  p {
    margin: 0;
  }
}

.radios {
  margin: 24px 0 0;
  padding: 0;

  > li {
    list-style: none;
    margin: 0 0 20px;
  }

  b {
    white-space: nowrap;
  }
}

.radioGroup {
  margin-bottom: 36px;
}

.button {
  width: 100%;
}
